import React from 'react'
import { Navigate } from 'react-router-dom';
import { decodeData } from '../utils/Helper';

const ValidateToken = ({children}) => {
    const token = decodeData(localStorage.getItem('y_g_n_d_a'));
    if(token){
        return children;
    }else{
        return <Navigate to="/admin/login" />
    }
  
}

export default ValidateToken;
